import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.143 4.4a.3.3 0 0 0-.3.3v14.6a.3.3 0 0 0 .3.3h11.713a.3.3 0 0 0 .3-.3V9.009h-2.908a1.7 1.7 0 0 1-1.7-1.7V4.4H6.143Zm8.805.99 2.218 2.219h-1.918a.3.3 0 0 1-.3-.3v-1.92ZM4.443 4.7a1.7 1.7 0 0 1 1.7-1.7h8.105a.7.7 0 0 1 .495.205l4.608 4.609a.7.7 0 0 1 .205.495V19.3a1.7 1.7 0 0 1-1.7 1.7H6.143a1.7 1.7 0 0 1-1.7-1.7V4.7Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.17 15v-3.15h2.498v.877h-1.486v.473h1.126v.81h-1.126V15H14.17Zm-3.463 0v-3.15h1.26c.99 0 1.71.72 1.71 1.575S12.957 15 11.967 15h-1.26Zm1.013-.855h.225c.427 0 .72-.293.72-.72 0-.428-.293-.72-.72-.72h-.225v1.44ZM7.534 15v-3.15H9.02c.72 0 1.215.495 1.215 1.148 0 .652-.495 1.147-1.215 1.147h-.472V15H7.534Zm1.013-1.71h.36c.18 0 .315-.135.315-.292 0-.158-.135-.293-.315-.293h-.36v.585Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=PdfFileIcon24.js.map